const fontWeightLight = 300;
const fontWeightRegular = 400;
const fontWeightMedium = 500;

const fontSizeHeading1 = 64;
const fontSizeHeading2 = 48;
const fontSizeHeading3 = 40;
const fontSizeHeading4 = 32;
const fontSizeHeading5 = 24;
const fontSizeHeading6 = 20;
const fontSizeHeading7 = 16;
const fontSizeHeading8 = 12;
const fontSizeHeading9 = 14;

const fontSizeBody = 13;
const fontSizeUppercase = 11;

const lineHeightHeading1 = 72 / fontSizeHeading1;
const lineHeightHeading2 = 56 / fontSizeHeading2;
const lineHeightHeading3 = 48 / fontSizeHeading3;
const lineHeightHeading4 = 40 / fontSizeHeading4;
const lineHeightHeading5 = 32 / fontSizeHeading5;
const lineHeightHeading6 = 28 / fontSizeHeading6;
const lineHeightHeading7 = 24 / fontSizeHeading7;
const lineHeightHeading8 = 16 / fontSizeHeading8;

const lineHeightBody = 20 / fontSizeBody;
const lineHeightUppercase = 11 / fontSizeUppercase;

export default {
  fontWeightLight,
  fontWeightRegular,
  fontWeightMedium,
  fontSizeHeading1,
  fontSizeHeading2,
  fontSizeHeading3,
  fontSizeHeading4,
  fontSizeHeading5,
  fontSizeHeading6,
  fontSizeHeading7,
  fontSizeHeading8,
  fontSizeBody,
  fontSizeUppercase,
  lineHeightHeading1,
  lineHeightHeading2,
  lineHeightHeading3,
  lineHeightHeading4,
  lineHeightHeading5,
  lineHeightHeading6,
  lineHeightHeading7,
  lineHeightHeading8,
  lineHeightBody,
  lineHeightUppercase,
  fontSizeHeading9
};



// WEBPACK FOOTER //
// src/dialpad/components/common/styles/typography.js